// Level options based on level number
export const LEVEL_OPTIONS = {
  2: ['Level 1', 'Level 2'],
  3: ['Level 1', 'Level 2', 'Level 3'],
  4: ['Level 1', 'Level 2', 'Level 3', 'Level 4'],
};

// Helper to get level options
export function getLevelOptions(levelNumber) {
  return LEVEL_OPTIONS[levelNumber] || [];
}